import React, { useRef, useEffect, useState } from 'react';
import {
    CFormGroup,
    CInputRadio,
    CLabel
} from '@coreui/react'

const PartyStrengthControl = ({props}) => {

    console.log(props)

    var parties = props.data.parties;
    var winner = props.data.winner;
    var selected = props.data.selected;
    var open = false;
    var cpvOrder = props.data.cpvOrder;

    // constructor(parties, winner, selected, cpvOrder) {
    //     this.parties = parties;
    //     this.winner = winner;
    //     this.selected = selected;
    //     this.open = false;
    //     this.cpvOrder = cpvOrder;
    // };

    function createElementFromHTML(htmlString) {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();
      
        // Change this to div.childNodes to support multiple top-level nodes.
        return div.firstChild;
    }    

    const onAdd = (map) => {
        console.log(this.parties);
        this._map = map;

        var partyStrengthDialogContainer = `<div style="display:inline;" class="maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group"></div>`
        var buttonElementOpen = document.createElement('button');
        buttonElementOpen.innerHTML = "☑️"
        buttonElementOpen.addEventListener('click', function handleClick(event) {
            event.target.parentElement.style.display = 'none'
            partyStrengthDialog.style.display = 'inline'
        });
        //var buttonElement = `<button class="maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group" style="position:absolute;top:5px;right:5px;">x</button>`
        partyStrengthDialogContainer = createElementFromHTML(partyStrengthDialogContainer);
        partyStrengthDialogContainer.appendChild(buttonElementOpen)

        var partyStrengthDialog = `
        <div style="display:none;padding:10px;padding-top:40px;position:relative" class="maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group">
        <div>
        <CFormGroup variant="checkbox">
            <CInputRadio className="form-check-input" id="radio1" name="radios" value="option1" />
            <CLabel variant="checkbox" htmlFor="radio1">Riding Winner</CLabel>
        </CFormGroup>
        </div>
        ${this.parties ? this.parties.map((p, i) => this.winner === p ? '<div>'+p+' strength ☑️</div>' : '<div>'+p+' strength</div>').join('') : ''}</div>`
        var buttonElement = document.createElement('button');
        
        buttonElement.innerHTML = "✖"
        buttonElement.style = 'position:absolute;top:0px;right:0px;'
        buttonElement.addEventListener('click', function handleClick(event) {
            event.target.parentElement.style.display = 'none'
            partyStrengthDialogContainer.style.display = 'inline'
        });

        //var buttonElement = `<button class="maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group" style="position:absolute;top:5px;right:5px;">x</button>`
        partyStrengthDialog = createElementFromHTML(partyStrengthDialog);
        partyStrengthDialog.appendChild(buttonElement)
        console.log(partyStrengthDialog)
        var partyStrengthWrap = document.createElement('div');
        partyStrengthWrap.appendChild(partyStrengthDialogContainer);
        partyStrengthWrap.appendChild(partyStrengthDialog);        
        return partyStrengthWrap

    }
     
    const onRemove = () => {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
    }
}

export default PartyStrengthControl;